import React, {useState} from 'react'
import {  Button, SelectAsync } from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'


const addMembers = ( {agency, onChange = () => {}} ) => {
  if (!agency) {
    return null
  }

  const [addMembers, setAddMembers] = useState(false)
  const [filterSuppliers, setFilterSuppliers] = useState([])

  const loadSupplierOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v2/supplier?search[identifier]=${query}&search[status]=2,4`)
        .then(response => response.json())
        .then((suppliers) => {
          resolve(suppliers.map(({ uid, userid }) => ({
            value: uid,
            label: userid
          })))
        })
        .catch(reject)
    })
  }, 250)

  const onSubmit = (event) => {
    event.preventDefault()
    setAddMembers(false)
    const newMembers = agency.members.concat(filterSuppliers.map((supplier) => ({uid: supplier.value})))
    onChange({ 
      ...agency,
      members: {
        ...newMembers
      }
    })
  }

  return (
    <div className='m-2'>
      { !addMembers && 
        <Button
          onClick={() => setAddMembers(true)}
          icon={['fa', 'plus']}
        >
          Add member
        </Button>
      }
      { addMembers && 
        <div className='flex space-x-2'>
          <SelectAsync
            label="New member"
            description="Select the supplier to add to the agency"
            value={filterSuppliers} 
            onChange={(supplier) => {
              setFilterSuppliers(supplier)
            }}
            cacheOptions
            loadOptions={(query) => loadSupplierOptions(query)}
            openMenuOnFocus
            placeholder="New Member"
            isClearable
            isMulti
          />
          <div className='mt-auto'>
            <Button
              onClick={(event) => onSubmit(event)}
            >
              Save
            </Button>
          </div>
          <div className='mt-auto'>
            <Button
              onClick={() => setAddMembers(false)}
              variant="outline"
              state="negative"
            >
              Cancel
            </Button>
          </div>
        </div>
      }
    </div>
  )
}

export default addMembers